export const formatMoney = (input: number, precission = 0) => {
  const string = Math.abs(input).toFixed(precission);
  const parts = string.split(".");
  const buffer = [];
  let formatedNumber = "";
  let number = parts[0];
  while (number.length > 0) {
    buffer.unshift(number.substring(number.length - 3, number.length));
    number = number.substring(0, number.length - 3);
  }
  formatedNumber = buffer.join(".");
  const decimals = parts[1];
  if (!!decimals && precission) {
    formatedNumber += "," + decimals;
  }
  return formatedNumber;
};
